import * as Moment from 'moment';
import { ApiConfigureDateTime, ApiGetSettings } from "../../../misc/api/DeviceLinkApi/StatStripXpress2";
import { FailedToConfigureDateTimeMessage, FailedToRetrieveSettingsMessage, FailedConfigureDeviceMessage } from "../../../misc/api/DeviceLinkApi/StatStripXpress2Messages";
import { isModelWithError, DeviceTypes } from '../../../misc/api/apiTypes';
import { CannotCreateWrapperErrorMessage } from '../../../misc/api/DeviceLinkApi/GenericMessages';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import { StudyScheduleSession, WebPortalClient, Visit } from 'webportalclient';

const createVisitWrapperIfNotExists = async (webPortalClient: WebPortalClient, visitScheduleId: string, subjectId: string): Promise<Visit> => {
    const visits = await webPortalClient.getVisits(undefined, `subjectId eq ${subjectId} and visitScheduleItemId eq ${visitScheduleId}`, undefined, undefined, undefined, undefined, undefined, true);


    if (visits['@odata.count'] < 1) {
        const scheduleVisit = await webPortalClient.getStudyScheduleVisit(visitScheduleId, "id,label");

        return await webPortalClient.postVisit({
            subjectId: subjectId,
            name: scheduleVisit.label,
            occurred: Moment().toISOString()
        });
    }

    return visits.value[0];
}

export const ConfigureStatStripXpress2 = async (client: WebPortalClient, userEmail: string, subjectId: string, selectedDevice: Device, sessionScheduleItem: StudyScheduleSession, onError: (message: string) => void, onComplete: () => void) => {
    try {
        const dateTimeResult = await ApiConfigureDateTime(selectedDevice.id, Moment().local().format());

        if (!dateTimeResult.isSuccess) {
            onError(FailedToConfigureDateTimeMessage);
            return;
        }

        const settingsResult = await ApiGetSettings(selectedDevice.id);

        if (settingsResult === null) {
            onError(FailedToRetrieveSettingsMessage);
            return;
        }

        const visitWrapperResult = await createVisitWrapperIfNotExists(client, sessionScheduleItem.studyScheduleVisitId, subjectId);

        if (isModelWithError(visitWrapperResult)) {
            return onError(CannotCreateWrapperErrorMessage);
        }

        const sessionResult = await client.postBloodGlucoseSession({
            visitId: visitWrapperResult.id,
            name: sessionScheduleItem.label,
            occurred: Moment().toISOString(),
            configurationOccurred: Moment().toISOString(),
            configurationTechnician: userEmail,
            serialNumber: settingsResult.monitorId,
            softwareVersion: settingsResult.softwareVersion,
            status: "BGSS_AWAITING_DATA",
            deviceType: DeviceTypes.StatStripXpress2
        });

        if (sessionResult == null) {
            return onError(CannotCreateWrapperErrorMessage);
        }
        
        await client.patchBloodGlucoseSession({
            configured: true,
        }, sessionResult.id);

        return onComplete();
    }
    catch (err) {
        onError(FailedConfigureDeviceMessage);
    }
}

